import { Tabs } from '../../../modules/tabs';
import { Accordion } from '../../../modules/accordion';
import { customAmountInput, invalidAmountError } from './donation-amounts';

interface MembershipType {
    name: string,
    price: {
        minimum: number,
        maximum: number
    }
}

const minimumAttribute = 'data-minimum';
const maximumAttribute = 'data-maximum';
const recommendedAttribute = 'data-recommended';
const nameAttribute = 'data-membership-level';
const typeDisplayAttribute = 'data-membership-type-display';

let membershipTypes: MembershipType[] = [];
const membershipTypeHiddenInput = document.querySelector('#Membership_type') as HTMLInputElement;
const typeDisplay = document.querySelector(`[${typeDisplayAttribute}]`) as HTMLElement;
const membershipSelectButtons = [].slice.call(document.querySelectorAll('[data-membership-level]')) as HTMLButtonElement[];
const outOfMembershipRangeError = document.querySelector('[data-amount-range-error]') as HTMLElement;
const membershipsForm = document.querySelector('#membershipsForm') as HTMLElement;

// Read membership level information
membershipSelectButtons.forEach(button => {
    const minimum = button.getAttribute(minimumAttribute);
    const maximum = button.getAttribute(maximumAttribute);
    const recommended = button.getAttribute(recommendedAttribute);
    const name = button.getAttribute(nameAttribute);

    // Parse and make sure the numbers make sense
    const resolvedMinimum = minimum ? parseFloat(minimum) : 1;
    const resolvedMaximum = maximum ? parseFloat(maximum) : Infinity;
    let resolvedRecommended = recommended ? parseFloat(recommended) : resolvedMaximum;

    // If the recommended amount is not in between the minimum and maximum, fall back to the maximum
    resolvedRecommended = (resolvedMaximum >= resolvedRecommended && resolvedRecommended >= resolvedMinimum) ? resolvedRecommended : resolvedMaximum;

    membershipTypes.push({
        name: name,
        price: {
            minimum: resolvedMinimum,
            maximum: resolvedMaximum
        }
    });

    button.addEventListener('click', (e) => {
        membershipTypeHiddenInput.value = name;
        customAmountInput.value = `${resolvedRecommended}`;
        outOfMembershipRangeError.setAttribute('hidden', '');
        invalidAmountError.setAttribute('hidden', '');
        deactivateLevels();
        button.setAttribute('aria-selected', 'true');
        membershipsForm.scrollIntoView({ behavior: 'smooth' });
    });
});

const deactivateLevels = () => {
    membershipSelectButtons.forEach(button => {
        button.setAttribute('aria-selected', 'false')
    })
}

export const displayCurrentLevel = (currentValue: number) => {
    if (membershipTypes.length > 0) {
        const matchingLevels = membershipTypes.filter(type => {
            return type.price.minimum <= currentValue && currentValue <= type.price.maximum;
        });
        if (matchingLevels.length > 0) {
            outOfMembershipRangeError.setAttribute('hidden', '');
            typeDisplay.removeAttribute('hidden');
        }
        else {
            outOfMembershipRangeError.removeAttribute('hidden');
            typeDisplay.innerHTML = '';
            typeDisplay.setAttribute('hidden', '');
        }
    }
}